import React from 'react';
import { GridLoader } from 'react-spinners';

const Spinner = () => (
  <div className="text-center row">
    <GridLoader color="red" />
  </div>
);
export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner.js